import { render, staticRenderFns } from "./zMenuButton.vue?vue&type=template&id=5319b3ce&scoped=true&"
import script from "./zMenuButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./zMenuButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319b3ce",
  null
  
)

export default component.exports